import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Generated class for the YoutubePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'youtube',
})
export class YoutubePipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}

  transform(_url: string, ...args) {
    if (!_url) {
      return '';
    }
    let searchParams = new URLSearchParams(_url);
    var param;

    if (searchParams.has('v')) {
      param = searchParams.has('v');
    } else if (_url.includes('https://youtu.be/')) {
      param = _url.replace('https://youtu.be/', '');
    } else if (_url.includes('https://www.youtube.com/embed/')) {
      param = _url.replace('https://www.youtube.com/embed/', '');
    }
    console.log(param);
    _url = 'https://www.youtube.com/embed/' + param;

    return this.dom.bypassSecurityTrustResourceUrl(_url);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/youtube/youtube.ts